import { render, staticRenderFns } from "./CarForbidden.vue?vue&type=template&id=70eaea81&scoped=true&"
import script from "./CarForbidden.vue?vue&type=script&lang=js&"
export * from "./CarForbidden.vue?vue&type=script&lang=js&"
import style0 from "./CarForbidden.vue?vue&type=style&index=0&id=70eaea81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eaea81",
  null
  
)

export default component.exports